<template>
  <div class="no-quietanze-wrapper" v-if="!payments.length">
    <p>Nessuna quietanza collegata a questo titolo</p>
  </div>
  <div v-else class="details-card-wrapper">
    <info-card
      v-for="(section, index) in sections"
      :key="index"
      :title="section.title"
      :rows="section.rows"
    ></info-card>
  </div>
</template>

<script>
import InfoCard from "@/components/insurance-ancillaries/details/InfoCard";
import { dash, enumText, dateOrDash, moneyOrDash } from "@/utils/details";

/*
 * Tab "Quietanza": le quietanze del titolo, in sola lettura. Di norma è una sola, ma il
 * titolo può averne una per payment_type: in quel caso si mostra una card per ognuna.
 */
export default {
  name: "Payment",
  components: { InfoCard },
  props: {
    resourceId: Number,
    dbRowData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    payments() {
      return this.dbRowData?.insurance_payments ?? [];
    },
    sections() {
      return this.payments.map((payment, index) => ({
        title:
          this.payments.length > 1
            ? `Quietanza ${index + 1}`
            : "Dati della quietanza",
        rows: [
          { label: "Tipo", value: enumText(payment.payment_type) },
          { label: "Stato", value: enumText(payment.status_payment) },
          { label: "Data scadenza", value: dateOrDash(payment.referring_at) },
          { label: "Netto", value: moneyOrDash(payment.net) },
          { label: "Tasse", value: moneyOrDash(payment.tax) },
          { label: "Lordo", value: moneyOrDash(payment.gross) },
          { label: "Sepa SDD", value: enumText(payment.sepa_sdd) },
          { label: "Inviata", value: enumText(payment.sent) },
          { label: "Modificata", value: enumText(payment.modified) },
          { label: "Commento", value: dash(payment.comment) },
        ],
      }));
    },
  },
};
</script>
<style lang="scss" scoped>
.no-quietanze-wrapper {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.no-quietanze-wrapper p {
  font-size: var(--font-size-md);
  font-weight: 500;
}
</style>
